<div
  class="nav-bar-container"
  [class.is-mobile]="isMobile()"
  [class.is-connected]="!!walletManager.signedWalletSignal()"
>
  @if (isMobile()) {
    <img
      class="nav-bar-container__brand-mark"
      src="/images/logo-sidebar-minified.png"
      [alt]="'KCC20 Logo'"
      [height]="29"
      [width]="46.11"
    />
    <b class="nav-bar-container__page-title">{{ pageTitle() }}</b>
    <div class="nav-bar-container__spacer"></div>
    @if (walletManager.signedWalletSignal()) {
      <div class="nav-bar-container__kas-pill">
        <kc-icon iconClass="kaspa-coin" size="xs" />
        <span>{{ balanceLabel() }}</span>
      </div>
    }
    <app-theme-toggle />
    <kcc20-notifications-bell />
    <kcc20-wallet-chip [compact]="true" />
  } @else {
    <kcc20-nav-breadcrumb [crumbs]="crumbs()" />
    <div class="nav-bar-container__spacer"></div>
    @if (walletManager.signedWalletSignal()) {
      <div class="nav-bar-container__kas-pill">
        <kc-icon iconClass="kaspa-coin" size="xs" />
        <span>{{ balanceLabel() }}</span>
      </div>
    }
    <div class="nav-bar-container__net-pill">
      <span class="nav-bar-container__dot"></span>
      <span>{{ networkName }}</span>
    </div>
    <app-theme-toggle />
    <kcc20-notifications-bell />
    <kcc20-wallet-chip />
  }
</div>
